// src/features/settings/NotificationsSettings.tsx
import React from 'react';
import { Box, Typography, FormControlLabel, Switch, Divider, FormGroup } from '@mui/material';
import { useTranslation } from 'react-i18next'; // ADDED: Import useTranslation

const NotificationsSettings: React.FC = () => {
    const { t } = useTranslation(); // ADDED: Use translation hook

    return (
        <Box>
            <Typography variant="h4" gutterBottom>{t('menu_notifications')}</Typography>
            <Box sx={{ py: 3 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{t('notifications_desc')}</Typography>
                <FormGroup>
                    <FormControlLabel control={<Switch defaultChecked />} label={t('notifications_product_updates')} />
                    <FormControlLabel control={<Switch />} label={t('notifications_security_alerts')} />
                    <FormControlLabel control={<Switch defaultChecked />} label={t('notifications_weekly_reports')} />
                </FormGroup>
            </Box>
        </Box>
    );
};

export default NotificationsSettings;